export const environment = {
    production: false,
    baseUrl: 'https://qa.evaltrix.com/api/',
    PAYMENT_GATEWAY_KEY_ID: 'your-key-id-here',
    MONTHLY_OFFER_ID: 'offer_RHB05BlenOHNCi',
    YEARLY_OFFER_ID: 'offer_RHB5o9AZCUcBap',
    DEFAULT_OFFER_ID: '',
    ENABLE_CLARITY: false,
    CLARITY_ID: 'fuginwgcwu',
    calendlyUrl: 'https://calendly.com/evaltrix-demos',
    // Feature flags
    ENABLE_CREATE_CODING_QUESTIONS: false,
    // Candidate autosave interval (ms) for OEQ and Coding
    candidateAutosaveMs: 60000,
    // Enable debounced OEQ autosave (extra; periodic save still runs). Default off.
    enableOeqDebouncedAutosave: false,
};


